import React, { useState ,useRef } from "react";
import { Grid, Modal, Hidden, Box, Chip } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi, { CancelToken } from "api/DnerhsApi";
import { trackPromise } from 'react-promise-tracker';
import FormInput from "../../Controls/Input";
import GetAppIcon from "@material-ui/icons/GetApp";
import commonMethods from "../../utils/commonMethods";
import Header from "components/Header";
import AlertMUI from '@material-ui/lab/Alert';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Button
} from "@material-ui/core";
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from '@material-ui/icons/Clear';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers";
import { ReporteApi } from "config/ApiUrls";
import Alert from "components/Alert";
import history from "../../utils/History";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Link as RouterLink, useParams ,useLocation} from "react-router-dom";
//import DescargarCertificadoVer from "layout/DescargarCertificado/FormVerCertificado";
import pie from "../../images/pie.png";
import encabezado from "../../images/encabezado.png";
import Fab from "@material-ui/core/Fab";
import "react-toastify/dist/ReactToastify.css";
import ReCAPTCHA from "react-google-recaptcha" ;

const useStyles = makeStyles((theme) => ({
  main: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4),
      paddingTop: theme.spacing(3),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8),
      paddingTop: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(16),
      paddingTop: theme.spacing(3),
    },
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
  button: {
    margin: theme.spacing(),
    paddingTop: theme.spacing(2),
  },
  alert: {
    color: "#ff0000",
  },
  modal: {
    position:'absolute',
    width: '90%',
    maxWidth: 400,
    backgroundColor: 'white',
    borderRadius: 5,
    borderColor: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2,4,2),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    focus:{
      outline: 'none'
    },
    outline: 'none',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  tableContainer: {
    overflowX: 'auto',
    [theme.breakpoints.down('sm')]: {
      overflowX: 'visible',
    },
  },
  mobileCard: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
  mobileCardRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  responsiveTitle: {
    fontSize: '1.25rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.5rem',
    },
  },
  responsiveBody: {
    fontSize: '0.875rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
  },
}));

const validationSchema = yup.object().shape({
  ci: yup.string().required("Es un campo requerido")
});

const Form = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const methods = useForm({
    resolver: yupResolver(validationSchema)
  });
  const { handleSubmit, errors, formState, reset } = methods;
  const [constancias, setConstancias] = useState([]);
  const [constanciaDetalles, setConstanciaDetalles] = useState([]);

  const [alumno, setAlumno] = useState("");
  const [cedula, setCedula] = useState("");
  const [formadora, setFormadora] = useState("");
  const [sede, setSede] = useState("");
  const [nacionalidad, setNacionalidad] = useState("");
  const [hoy, setHoy] = useState("");
  const [mesActual, setMesActual] = useState("");
  const [anhoActual, setAnhoActual] = useState("");

  const [warningMessage, setWarningMessage] = useState();
  const captchaRef = useRef(null)
  const [item, setItem] = useState();
  
  const onSubmit = async (dataForm) => {
    setWarningMessage();

    let source = CancelToken.source();
    try {

      let url = `/constancias/listado-practicas-cedula?cedula=${dataForm.ci}`;
      const { data } = await DnerhsApi(url, {
        cancelToken: source.token,
      });

      if (data && data.length > 0) {
        setConstancias(data);
        
      } else {
        setConstancias([]);
        setWarningMessage("¡No se encontraron datos para la búsqueda!")
      }

    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      } 
    }
  };

  const downloadFile = async () => {
    try {
      let name = "constancia"
      let constanciaId = item?.constanciaId || item?.id;
      let url = `${ReporteApi.baseURL}?name=constancia&constanciaId=${constanciaId}`;
      trackPromise(commonMethods.downloadFile(url, `${name}_${new Date()}.pdf`, true));
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      } 
    }
  };

  const handleFormKeyPress = (event) => {
      if (event.key == "Enter") {
        event.preventDefault();
        handleSubmit(onSubmit)();
      }
  }
  const onChange = () => {
   console.log("Hubo un cambio");
   console.log(captchaRef.current.getValue());
   if(captchaRef.current.getValue()){
    console.log("El usuario no es un robot!!!");
    downloadFile();
   }
   abrirCerrarModal();
  }
  const resetSearch = () => {
    reset();
    setConstancias([]);
  }
/*MODAL*/
const [modal, setModal]=useState(false);
const abrirConstancia =(item)=>{
  setAlumno(item.practicaDetalle.convenioEstudiante.estudiante.nombres +" " + item.practicaDetalle.convenioEstudiante.estudiante.apellidos);
    setNacionalidad(item.practicaDetalle.convenioEstudiante.estudiante.nacionalidad.nombre);
    setCedula(item.practicaDetalle.convenioEstudiante.estudiante.cedulaIdentidad);
    setFormadora(item.practicaDetalle.convenioEstudiante.convenio.institucionFormadora.institucion);
    setSede(item.practicaDetalle.convenioEstudiante.convenio.institucionFormadora.sede);
    setConstanciaDetalles([item]);
        const fecha = new Date();
        setHoy(fecha.getDate());
       
        const monthNameLong = fecha.toLocaleString("es-AR", { month: "long" });

        setMesActual(monthNameLong);
        setAnhoActual(fecha.getFullYear());

        abrirCerrarModal();
        
}
const abrirCerrarModal =(item)=>{
  setItem(item);
  setModal(!modal);     
}
  const cerrarModal =()=>{
  setModal(!modal);     
}
const bodyModal2= (

  <div className={classes.modal} align="center" classes={{focused: classes.outlinedInputFocused}}
  style={{fontSize: 0.875+'rem', fontFamily: 'Roboto', fontWeight: 400,
  lineHeight: 1.43,
  letterSpacing: 0.01071+'em'
}} >
      <Card >
        <CardContent>
          <Typography variant="h6" color="primary" gutterBottom>
            Descargar Certificado
          </Typography>
          <Typography variant="body1" style={{ marginTop: 16, marginBottom: 16 }}>
            ¿Desea descargar el certificado de práctica?
          </Typography>
                   {/* Comentamos el ReCAPTCHA temporalmente */}
        {/*
      <ReCAPTCHA
      ref={captchaRef}
      sitekey="6Lefd0kqAAAAAAhIVvfr-woIwH2S0_dDYPxQsDBa"
   //   sitekey="6LcHohopAAAAAEglVfXf_DUn2hye3GkcbHnl5PA1"
      onChange={onChange}
                         />
          */

                        }

        <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              startIcon={<GetAppIcon />}
              onClick={()=>{downloadFile(); cerrarModal();}}>
              Descargar
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="default"
              onClick={()=>cerrarModal()}>
              Cancelar
            </Button>
          </Grid>

        </Grid>
        </CardContent>
    </Card>
  </div>

);

  // Función para renderizar certificados como cards en móvil
  const renderCertificadoCard = (item, key) => {
    return (
      <Card key={item.id} className={classes.mobileCard}>
        <CardContent>
          <Box className={classes.mobileCardRow}>
            <Typography variant="body2" color="textSecondary">
              <strong>Estudiante:</strong>
            </Typography>
            <Typography variant="body2">
              {item.practicaDetalle?.convenioEstudiante?.estudiante?.nombres + " " + item.practicaDetalle?.convenioEstudiante?.estudiante?.apellidos}
            </Typography>
          </Box>
          <Box className={classes.mobileCardRow}>
            <Typography variant="body2" color="textSecondary">
              <strong>Institución:</strong>
            </Typography>
            <Typography variant="body2">
              {item.practicaDetalle?.convenioEstudiante?.convenio?.institucionFormadora?.institucion}
            </Typography>
          </Box>
          <Box className={classes.mobileCardRow}>
            <Typography variant="body2" color="textSecondary">
              <strong>Sede:</strong>
            </Typography>
            <Typography variant="body2">
              {item.practicaDetalle?.convenioEstudiante?.convenio?.institucionFormadora?.sede}
            </Typography>
          </Box>
          <Box className={classes.mobileCardRow}>
            <Typography variant="body2" color="textSecondary">
              <strong>Carrera:</strong>
            </Typography>
            <Typography variant="body2">
              {(item.convenioCarrera?.carreraPrograma?.descripcion==="Postgrado"? "Postgrado - " + item.convenioCarrera?.nombrePostgrado?.descripcion : item.convenioCarrera?.carreraPrograma?.descripcion )}
            </Typography>
          </Box>
          <Box className={classes.mobileCardRow} style={{ marginTop: 16, justifyContent: 'center' }}>
            <Tooltip title="Descargar" aria-label="descargar">
              <IconButton
                size="small"
                aria-label="descargar"
                color="primary"
                onClick={() => abrirCerrarModal(item)}
              >
                <GetAppIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Ver Certificado" aria-label="ver">
              <IconButton
                size="small"
                aria-label="ver"
                color="secondary"
                variant="text"
                component={RouterLink}
                to={`/descargarCertificado/ver/${item.practicaDetalle?.convenioEstudiante?.estudiante?.cedulaIdentidad}`}
              >
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </CardContent>
      </Card>
    );
  };

  return (
    <>

      <Header />
      <div className={classes.main}>
        <Grid item xs={12}>
          <Typography align="left" variant="h5" color="primary" className={classes.responsiveTitle}>
            Descargar Certificado de Práctica
          </Typography>
        </Grid>
        <div>
          <FormProvider {...methods}>
            <form
             onKeyPress={handleFormKeyPress}
            >
              <Grid
                container
                direction="row"
              >
                <Grid item xs={12} sm={8} md={6} className={classes.form}>
                  <Grid item xs={12} className={classes.field}>
                    <FormInput
                      name="ci" label="Ingrese el número de cédula"
                      errorobj={errors}
                      required
                      InputProps={{
                        endAdornment: (
                          <>
                            <InputAdornment position="end" onClick={resetSearch}>
                              <IconButton>
                                <ClearIcon />
                              </IconButton>
                            </InputAdornment>
                            <InputAdornment position="end" onClick={handleSubmit(onSubmit)}>
                              <IconButton>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          </>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </FormProvider>
        </div>
        <Grid container className={classes.form}>
          {warningMessage &&
            <Grid item xs={12}>
              <AlertMUI severity="warning">No se encontraron datos para la búsqueda </AlertMUI>
            </Grid>
          }
          <Grid item xs={12}>
            <Typography align="center" variant="h6" color="primary" className={classes.responsiveTitle}>
              Certificados de prácticas
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {/* Vista de tabla para desktop */}
            <Hidden smDown>
              <div className={classes.tableContainer}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Estudiante</TableCell>
                      <TableCell align="left">Institucion</TableCell>
                      <TableCell align="left">Sede</TableCell>
                      <TableCell align="left">Carrera</TableCell>
                      <TableCell align="center">Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {constancias.length > 0 ?
                      constancias.map((item, key) => (
                        <TableRow key={item.id}>
                          <TableCell align="left">{item.practicaDetalle?.convenioEstudiante?.estudiante?.nombres + " " + item.practicaDetalle?.convenioEstudiante?.estudiante?.apellidos}</TableCell>
                          <TableCell align="left">{item.practicaDetalle?.convenioEstudiante?.convenio?.institucionFormadora?.institucion}</TableCell>
                          <TableCell align="left">{item.practicaDetalle?.convenioEstudiante?.convenio?.institucionFormadora?.sede}</TableCell>
                          <TableCell align="left">
                          {(item.convenioCarrera?.carreraPrograma?.descripcion==="Postgrado"? "Postgrado - " + item.convenioCarrera?.nombrePostgrado?.descripcion : item.convenioCarrera?.carreraPrograma?.descripcion )}</TableCell>

                          <TableCell align="center">

                            <Tooltip title="Descargar" aria-label="ver">
                                <IconButton
                                  size="small"
                                  aria-label="ver"
                                  color="primary"
                                  onClick={() => abrirCerrarModal(item)}
                                >
                                  <GetAppIcon />
                                </IconButton>
                            </Tooltip>
                              <Tooltip
                                title="Ver Certificado"
                                aria-label="ver"
                              >
                                <IconButton
                                  size="small"
                                  aria-label="ver"
                                  color="secondary"
                                  variant="text"
                                  component={RouterLink}
                                  to={`/descargarCertificado/ver/${item.practicaDetalle?.convenioEstudiante?.estudiante?.cedulaIdentidad}`}
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              </Tooltip>

                          </TableCell>
                        </TableRow>
                      ))
                      :
                      <TableRow>
                        <TableCell colSpan={12}>
                          <Typography align="center" color="primary" variant="body1">No hay datos para mostrar</Typography>
                        </TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </div>
            </Hidden>

            {/* Vista de cards para móvil */}
            <Hidden mdUp>
              {constancias.length > 0 ? (
                constancias.map((item, key) => renderCertificadoCard(item, key))
              ) : (
                <Card className={classes.mobileCard}>
                  <CardContent>
                    <Typography align="center" color="primary" variant="body1">
                      No hay datos para mostrar
                    </Typography>
                  </CardContent>
                </Card>
              )}
            </Hidden>
          </Grid>
          <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item className={classes.button}>
                <Button
                  variant="contained"
                  color="default"
                  component={RouterLink}
                  to={`/login`}
                >
                  Atrás
                </Button>
              </Grid>
            </Grid>
        </Grid>
      </div>
      <Modal backdrop="static"
        open={modal} variant="standard"
        InputProps={{
                disableUnderline: true,
              }}
              style={{outline: 'none'}}
              classes={{focused: classes.outlinedInputFocused}}
      >
      
        {bodyModal2}
      </Modal>
    </>
  );
};

export default Form;
